import type {
  DeliveryApiDatasource,
  ListSalesDeliveriesInput,
} from '../datasources/delivery-api.datasource';
import type {
  SalesDeliveriesListResponse,
  SalesDelivery,
} from '../../domain/entities/delivery.entity';

export class DeliveryRepositoryImpl {
  private api: DeliveryApiDatasource;

  constructor(api: DeliveryApiDatasource) {
    this.api = api;
  }

  async listSalesDeliveries(
    input?: ListSalesDeliveriesInput,
  ): Promise<SalesDeliveriesListResponse> {
    return this.api.listSalesDeliveries(input);
  }

  async getSalesDelivery(id: string): Promise<SalesDelivery> {
    return this.api.getSalesDelivery(id);
  }
}
